import Model from "./Model";
import KnowledgeAssociationModel from "./KnowledgeAssociationModel";

export default class KnowledgeModel extends Model {
  id: number;
  name: string;
  parentId: number;
  private _colors: Object;

  constructor(knowledge: any, getters: any) {
    super(getters);
    this.id = knowledge.id;
    this.name = knowledge.name;
    this.parentId = knowledge.parentId;
    this._colors = {
      9496: "rgba(254, 213, 0, 0.5)",
      12489: "rgba(254, 213, 0, 0.5)",
      1: "rgba(254, 213, 0, 0.5)",
      9497: "rgba(251, 123, 1, 0.5)",
      12490: "rgba(251, 123, 1, 0.5)",
      2: "rgba(251, 123, 1, 0.5)",
      9498: "rgba(38, 159, 249, 0.5)",
      12491: "rgba(38, 159, 249, 0.5)",
      3: "rgba(38, 159, 249, 0.5)",
      9499: "rgba(102, 255, 189, 0.5)",
      12492: "rgba(102, 255, 189, 0.5)",
      4: "rgba(102, 255, 189, 0.5)",
      9500: "rgba(237, 106, 180, 0.5)",
      12493: "rgba(237, 106, 180, 0.5)",
      5: "rgba(237, 106, 180, 0.5)",
    };
  }
  color(highlighted = true) {
    let mappedColor = this._colors[this.id];
    if (!mappedColor) {
      const criteria = this.name.split(" - ")[0];
      const number = criteria[criteria.length - 1];
      mappedColor = this._colors[number];
    }

    const color = mappedColor.split(", 0.5)")[0];
    return `${color}, ${highlighted ? 0.5 : 0.1})`;
  }
  assocations() {
    return this.getters.assocationsByKnowledgeId(this.id);
  }
  questions() {
    return this.assocations()
      .filter(
        (association: KnowledgeAssociationModel) => association.questionId
      )
      .map((association: KnowledgeAssociationModel) => association.question());
  }
  children() {
    return this.getters.knowledgesByParentId(this.id);
  }
}
